// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1n-mg","choiceBoxes":"toolbarselects_choiceBoxes__6y5DD","simpleField":"toolbarselects_simpleField__-nkhk"};